import React, {useEffect, useState} from 'react';
import { withStyles } from "@mui/styles";
import {Card, CardContent, Checkbox, Dialog, DialogContent, DialogTitle, IconButton, Typography} from '@mui/material';
import {connect, setStore} from "trim-redux";
import {useTranslation} from "react-i18next";
import {Close} from "@mui/icons-material";
import {Styles} from "../../../../config/design/styles";
import Button from "@mui/material/Button";
import {getMediaURL, scrollTop, showExactDate} from "../../../../config/values";
import {ChevronRight} from "lucide-react";
import Grid from "@mui/material/Grid2";
import LoadingButton from "../../../components/elements/LoadingButton";
import axios from "axios";
import {defaultVariables} from "../../../../config";
import {useSnackbar} from "notistack";
import clsx from "clsx";

function AssignCourierManually({order,role,classes,reload }) {
    const { t } = useTranslation();
    const [open,setOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [data, setData] = useState(null);
    const [courier, setCourier] = useState(null);

    const [submitLoading, setSubmitLoading] = useState(false);
    const loginToken = localStorage.getItem("ACT");
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`,
        }
    }
    const { enqueueSnackbar } = useSnackbar();

    const loadData = () =>{
        setFetching(true);
        axios.get(`${defaultVariables.url}/couriers/get-available/${order.id}`,config)
            .then(response => {
                setData(response.data);
                setLoading(false);
                setFetching(false);
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
                setFetching(false);
                setStore({error:404})
            });
    }
    useEffect(() => {
        if (!fetching) {
            scrollTop();
            loadData();
        }
    },[]);
    const handleRequest = async () => {
        setSubmitLoading(true);
        const data = new FormData();
        data.append('order_id', order.id);
        data.append('courier_id', courier.id);
        console.log(order.id,courier.id)
        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/couriers/set-manually`, data, config);
            setSubmitLoading(false);
            reload();
            setOpen(false);
        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);

        }
    }
    const autoCheck = async () => {
        setSubmitLoading(true);
        const data = new FormData();
        data.append('order_id', order.id);

        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/couriers/auto-check`, data, config);
            setSubmitLoading(false);
            reload();
            setOpen(false);
        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);
            if(error.response.status === 422){
                enqueueSnackbar(t('noAutoCourierFound'), { variant: 'warning' });
            }


        }
    }
    return (
        <>
            <Button
                onClick={() => setOpen(true)}
                endIcon={<ChevronRight/>}
                color="secondary"
                variant="contained"
            >
                {t('assignCourierManually')}
            </Button>
            <Dialog  open={open} onClose={() => setOpen(false)} fullWidth maxWidth="md">
                <DialogTitle className="dialog-title">
                    {t('assignCourierManually')}
                    <IconButton
                        onClick={() => setOpen(false)}
                        style={{position:"absolute",right:15,top:15}}
                        size="small"
                    >
                        <Close className="lucide-icon"/>
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        {
                            !loading &&
                            <Grid item size={12}>
                                <Grid container spacing={2}>
                                    {
                                        data.map((item,index) => {
                                            let isSelected = item.id === courier?.id
                                            return (
                                                <Grid item size={{xs:12,sm:6,md:4}} key={index}>
                                                    <Card
                                                        className={clsx('categoryChooserCard green-selected',isSelected ? "active" : "")}
                                                        selected={isSelected}
                                                        onClick={() => setCourier(item)}
                                                    >
                                                        <CardContent>
                                                            <Typography variant="body1">{item.first_name} {item.last_name} </Typography>
                                                            <Typography variant="body1">{!!item.mobile ? item.mobile : item.email}</Typography>
                                                            <div className="cat-selected secondary">
                                                                {isSelected && <Checkbox checked={true} color='secondary'/>}
                                                            </div>
                                                        </CardContent>
                                                    </Card>
                                                </Grid>
                                            )
                                        })
                                    }
                                </Grid>

                            </Grid>
                        }

                        <Grid item size={12} style={{display:"flex",alignItems:"center",gap:10,justifyContent:"center"}}>

                            <LoadingButton
                                variant="outlined"
                                color="secondary"
                                onClick={() => autoCheck()}
                                loading={submitLoading}
                            >
                                {t("autoCheck")}
                            </LoadingButton>
                            <LoadingButton
                                className="confirm-btn"
                                variant="contained"
                                color="secondary"
                                onClick={() => handleRequest()}
                                loading={submitLoading}
                                disabled={!courier}
                            >
                                {t("save")}
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </>

    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(AssignCourierManually));
